export const userInfoSelector = (state: any) => state?.userInfo || {};
